import {
  Component,
  Input,
  ViewChild
} from '@angular/core';

import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';

import { TranslocoDirective } from '@jsverse/transloco';

export enum ModalVariant {
  AUTHORIZED,
  REMOVED,
  ERROR
}

@Component({
    selector: 'app-ambassador-response-modal',
    templateUrl: './ambassador-response-modal.component.html',
    styleUrls: ['./ambassador-response-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent]
})
export class AmbassadorResponseModalComponent {
  @Input() modalId: string;
  @ViewChild(ModalComponent) modal: ModalComponent;
  public variant: ModalVariant;
  public name = '';

  get isAuthorized(): boolean {
    return ModalVariant.AUTHORIZED === this.variant;
  }

  get isRemoved(): boolean {
    return ModalVariant.REMOVED === this.variant;
  }

  get isError(): boolean {
    return ModalVariant.ERROR === this.variant;
  }

  show(name = '', variant: ModalVariant = ModalVariant.ERROR) {
    this.name = name;
    this.variant = variant;
    this.modal.show();
  }

  close() {
    this.modal.close();
  }
}
